var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.35 20.775L9 18.9L4.35 20.7C4.18333 20.7667 4.02067 20.7877 3.862 20.763C3.70333 20.7383 3.55767 20.684 3.425 20.6C3.29233 20.516 3.18833 20.4037 3.113 20.263C3.03767 20.1223 3 19.9597 3 19.775V5.75C3 5.53333 3.06267 5.34167 3.188 5.175C3.31333 5.00833 3.484 4.88333 3.7 4.8L8.35 3.225C8.45 3.19167 8.55433 3.16667 8.663 3.15C8.77167 3.13333 8.884 3.125 9 3.125C9.116 3.125 9.22867 3.13333 9.338 3.15C9.44733 3.16667 9.55133 3.19167 9.65 3.225L15 5.1L19.65 3.3C19.8167 3.23333 19.9793 3.21267 20.138 3.238C20.2967 3.26333 20.4423 3.31733 20.575 3.4C20.7077 3.48267 20.812 3.59533 20.888 3.738C20.964 3.88067 21.0013 4.043 21 4.225V18.25C21 18.4667 20.9377 18.6583 20.813 18.825C20.6883 18.9917 20.5173 19.1167 20.3 19.2L15.65 20.775C15.55 20.8083 15.446 20.8333 15.338 20.85C15.23 20.8667 15.1173 20.875 15 20.875C14.8827 20.875 14.7703 20.8667 14.663 20.85C14.5557 20.8333 14.4513 20.8083 14.35 20.775ZM14 18.55V6.85L10 5.45V17.15L14 18.55Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.824cb3eabcf5259bc600918d1fe0bde7.svg";
export { ForwardRef as ReactComponent };